import React from 'react';

export const DependencyHeader = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: number;
  width?: number;
}) => (
  <svg
    width={width ?? 41}
    height={height ?? 41}
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_577_12816" fill="white">
      <rect x="5.74365" y="5.88574" width="12.1592" height="12.1592" rx="2" />
    </mask>
    <rect
      x="5.74365"
      y="5.88574"
      width="12.1592"
      height="12.1592"
      rx="2"
      stroke={color ? color : '#5243aa'}
      strokeWidth="6"
      mask="url(#path-1-inside-1_577_12816)"
    />
    <mask id="path-2-inside-2_577_12816" fill="white">
      <rect x="14.664" y="14.8062" width="12.1592" height="12.1592" rx="2" />
    </mask>
    <rect
      x="14.664"
      y="14.8062"
      width="12.1592"
      height="12.1592"
      rx="2"
      stroke={color ? color : '#5243aa'}
      strokeWidth="6"
      mask="url(#path-2-inside-2_577_12816)"
    />
    <mask id="path-3-inside-3_577_12816" fill="white">
      <rect x="23.5844" y="23.7266" width="12.1592" height="12.1592" rx="2" />
    </mask>
    <rect
      x="23.5844"
      y="23.7266"
      width="12.1592"
      height="12.1592"
      rx="2"
      stroke={color ? color : '#5243aa'}
      strokeWidth="6"
      mask="url(#path-3-inside-3_577_12816)"
    />
  </svg>
);
